import React from "react";
import "./Proyectos.css";
import Card from "./Card.jsx";
import excel from "./excel.webp";
import aficheword from "./aficheword.jpg";
import excelcurso from "./excelcurso.jpg"
function Cursos() {
    return (
        <div>
            <h1 className="titulo">Cursos Office</h1>
            <div className="contenedor-proyectos">
                <Card
                    nombre={'100 HOJAS DE EJERCICIOS PRACTICOS EXCEL'}
                    link="https://go.hotmart.com/V77758007W?dp=1"
                    link2={"https://go.hotmart.com/V77758007W"}
                    imagen={excel}
                />
                <Card
                    nombre={'Curso completo de excel de 0 a experto'}
                    link="https://go.hotmart.com/I77811031Q?ap=3571"
                    link2={"https://go.hotmart.com/I77811031Q"}
                    imagen={excelcurso}
                />
                <Card
                nombre={'Curso de 0 a profesional word'}
                    link="https://go.hotmart.com/B77810883Q?dp=1"
                    link2={"https://go.hotmart.com/B77810883Q"}
                    imagen={aficheword}
                />
                

            </div>
        </div>
        // </div>
    );
}

export default Cursos;
